<template>
  <v-dialog :value="filterForm.modalType === 'agency'" max-width="1000" persistent>
    <v-card class="text-center">
      <template v-if="errorMessage">
        <v-alert type="error">{{ errorMessage }}</v-alert>
      </template>
      <validation-observer v-slot="{ handleSubmit }">
        <v-card-title class="text-sm-left font-weight-bold">
          Chuyển loại hình phù hợp (Đại lý / thường)
          <v-spacer />
          <v-icon aria-label="Close" @click="hideModal">mdi-close</v-icon>
        </v-card-title>
        <v-card-text class="px-6">
          <v-row>
            <v-col cols="12" md="12">
              <validation-provider
                  v-slot="{ errors }"
                  class="mb-2"
                  rules="required"
                  name="Chọn Thường / Đại lý"
              >
                <v-autocomplete
                    v-model="typeChangeStore"
                    :items="storeAgencyList"
                    item-text="name"
                    item-value="code"
                    label
                    :error-messages="errors"
                />
              </validation-provider>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions class="px-0 group-btn--form">
          <v-btn color="success" @click.prevent="handleSubmit(saveChange)">Lưu lại</v-btn>
          <v-spacer />

          <v-btn color="primary" @click="hideModal">Hủy bỏ</v-btn>
        </v-card-actions>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>
<script>
import RepositoryFactory from '../../../repositories/RepositoryFactory';
const ContactRepository = RepositoryFactory.get('contact');

export default {
  $_veeValidate: {
    validator: 'new'
  },
  props: {
    filterForm: {
      default: () => ({})
    },
    contacts: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      showModal: false,
      errorMessage: '',
      storeAgencyList: [
        {
          code: 0,
          name: 'Thường'
        },
        {
          code: 1,
          name: 'Đại lý'
        }
      ],
      typeChangeStore: ''
    };
  },
  computed: {

  },
  methods: {
    hideModal: function() {
      const filterFormTemp = this.filterForm;
      filterFormTemp.modalType = '';
      this.errorMessage = '';
      this.typeChangeStore = ''
    },
    async saveChange() {
      let changeContactList = this.contacts.filter(contact => contact.checkbox);
      if (changeContactList.length === 0) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn khách hàng cần thay đổi!!!'
        });
      }

      if (this.filterForm.contactAgency && this.typeChangeStore) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Lỗi. Contact đang ở số đại lý!'
        });
      }

      if (!this.filterForm.contactAgency && !this.typeChangeStore) {
        return this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Lỗi. Contact đang ở số thường!'
        });
      }

      const dataUpdate = {
        contactIds: changeContactList.map(contact => contact.id),
        store: this.typeChangeStore
      }

      this.loading = this.$loading.show();
      const response = await ContactRepository.updateContactStoreAgency(dataUpdate);
      this.loading.hide();
      if (response.error) {
        this.errorMessage = _.get(response, 'message', '');
        return;
      }

      this.$swal({
        title: 'Chuyển loại hình phù hợp (Đại lý / thường) thành công!',
        confirmButtonText: 'Đồng ý'
      }).then(() => {
        this.hideModal();
        Bus.$emit('contact-list-filter', this.filterForm);
        Bus.$emit('contact-status-list');
      });
    }
  }
};
</script>

<style scoped>
/deep/ .v-subheader.theme--light {
  font-size: 10px;
  font-weight: bold;
}
</style>